import { useEffectOnce } from "usehooks-ts";

export function useSubscribeEffect(service: {
  subscribe(): void;
  unsubscribe(): void;
}) {
  useEffectOnce(() => {
    service.subscribe();
    return () => service.unsubscribe();
  });
}
